import React from "react";
import PersianDateTimeFilter from "./dateTimeFilter/PersianDateTimeFilter";
import EmotionDashboard from "../components/charts/EmotionDashboard";

export default function OrdersOverview({ onApplyFilter, height }) {
  return (
    <div
      className="
        relative w-full h-full
        flex flex-col gap-3 sm:gap-4
      "
      style={{ height: height || "auto" }}
    >
      {/* ================= Filter Card ================= */}
      {/* ⚠️ overflow-hidden حذف شد چون پاپ‌آپ فیلتر باید بتونه از کارت بیرون بزنه */}
      <div
        className="
          relative w-full shrink-0
          rounded-2xl
          bg-gradient-to-br from-slate-100 via-teal-50 to-teal-100/70
          dark:bg-gradient-to-br dark:from-slate-900 dark:via-[#0B2E2F] dark:to-slate-900
          backdrop-blur-xl
          border border-teal-500/20 dark:border-teal-400/15
          shadow-[0_10px_40px_-20px_rgba(15,118,110,0.45)]
          dark:shadow-[0_10px_40px_-20px_rgba(0,0,0,0.85)]
          p-3 sm:p-4
          transition-colors duration-500
          z-30
        "
      >
        {/* خط تزئینی طلایی بالا — گوشه‌ها با rounded-2xl هماهنگ شدن */}
        <div className="pointer-events-none absolute top-0 inset-x-0 h-[2px] bg-gradient-to-l from-transparent via-amber-400/70 to-transparent rounded-t-2xl" />

        {/* گلوی طلایی — حالا با isolate جدا شده تا نشت نکنه */}
        <div className="pointer-events-none absolute inset-0 rounded-2xl overflow-hidden">
          <div className="absolute -top-16 -right-16 h-32 w-32 rounded-full bg-amber-300/15 blur-3xl dark:bg-amber-400/10" />
        </div>

        {/* محتوای فیلتر — z بالاتر از تزئینات */}
        <div className="relative z-10">
          <PersianDateTimeFilter onApplyFilter={onApplyFilter} />
        </div>
      </div>

      {/* ================= Emotion Chart Card ================= */}
      <div
        className="
          relative w-full flex-1 min-h-0 overflow-hidden
          rounded-2xl
          bg-gradient-to-br from-slate-100 via-teal-50 to-teal-100/70
          dark:bg-gradient-to-br dark:from-slate-900 dark:via-[#0B2E2F] dark:to-slate-900
          backdrop-blur-xl
          border border-teal-500/20 dark:border-teal-400/15
          shadow-[0_10px_40px_-20px_rgba(15,118,110,0.45)]
          dark:shadow-[0_10px_40px_-20px_rgba(0,0,0,0.85)]
          p-3 sm:p-4
          transition-colors duration-500
          flex flex-col
          z-10
        "
      >
        {/* خط تزئینی طلایی بالا */}
        <div className="pointer-events-none absolute top-0 inset-x-0 h-[2px] bg-gradient-to-l from-transparent via-amber-400/70 to-transparent" />

        {/* گلوی teal */}
        <div className="pointer-events-none absolute -bottom-16 -left-16 h-40 w-40 rounded-full bg-teal-400/15 blur-3xl dark:bg-teal-500/10" />

        <div className="relative flex-1 min-h-0 overflow-hidden">
          <EmotionDashboard />
        </div>
      </div>
    </div>
  );
}